'use client'

import { useEffect, useRef } from 'react'
import { useSearchParams } from 'next/navigation'
import {
  buildUTMKey,
  readUTMPending,
  recordAnonymousUTM,
  recordAuthenticatedUTM,
  clearUTMPending,
  UTM_SESSION_SYNCED_KEY,
  type UTMHistory,
} from '@/lib/utm'
import { trackUTMAction } from '../_actions/utm-actions'

interface UTMTrackerProps {
  userId?: string
}

export function UTMTracker({ userId }: UTMTrackerProps) {
  const searchParams = useSearchParams()
  const initialPendingRef = useRef<UTMHistory>(readUTMPending())

  useEffect(() => {
    const utmKey = buildUTMKey(searchParams)
    if (!utmKey) return

    const now = new Date().toISOString()

    if (userId) {
      recordAuthenticatedUTM(utmKey, now)
      trackUTMAction({ [utmKey]: [now] }).catch(() => {})
    } else {
      recordAnonymousUTM(utmKey, now)
    }
  }, [searchParams, userId])

  useEffect(() => {
    if (!userId) return
    if (sessionStorage.getItem(UTM_SESSION_SYNCED_KEY)) return

    sessionStorage.setItem(UTM_SESSION_SYNCED_KEY, '1')

    const pending = initialPendingRef.current
    if (Object.keys(pending).length > 0) {
      trackUTMAction(pending)
        .then(() => clearUTMPending())
        .catch(() => {})
    }
  }, [userId])

  return null
}
